import React, { Component } from 'react'

import * as actions from "../actions";
import DeleteItemLink from "../../common/components/delete-item-link";

export const DeletePollLink = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    return (
      <DeleteItemLink
        onConfirmClick={ this.handleDeleteClick }
        heading="Remove Poll?"
        body="Are you sure you would like to remove this poll?"
      />
    )
  },
  handleDeleteClick: function() {
    actions.deletePoll(this.props.pollId);
  }
});



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/polls/components/delete-poll.es6